module.exports = __webpack_public_path__ + "img/宣传_188.9ad5bb42.jpg";